import { useEffect } from "react";
import ErrorBoundary from "../../components/global/ErrorBoundary";
import NotificationsSettingsPageRoutes from "../../routes/NotificationSettingsPageRoutes";
import useFeatureFlags from "../../services/utils/custom hooks/Feature Flagging/useFeatureFlags";
import dataConstants from "../../constants/dataConstants";
import { useHistory } from "react-router-dom";

function NotificationsPage(): JSX.Element {
  const { isSectionActive } = useFeatureFlags();
  const history = useHistory();

  useEffect(() => {
    if (!isSectionActive(dataConstants.FeatureFlagSectionKeys.NOTIFICATIONS)) {
      history.push('/unauthorized')
    }
  }, [])

  return (
    <ErrorBoundary fallbackClassName="col-span-3">
      <NotificationsSettingsPageRoutes />
    </ErrorBoundary>
  );
}

export default NotificationsPage;
